import { useQuery } from '@tanstack/react-query';
import { checkStartupEligibility } from '../api/startups.api';

/**
 * Gates the Create Startup wizard (MYN-46/FR-13) before the user fills any of
 * it out, instead of only discovering a block at Step 4's work-email OTP
 * send. A rejection here isn't the source of truth - `sendWorkEmailOtp`/
 * `createStartup` re-check the same rules server-side regardless.
 */
export function useStartupEligibility() {
  return useQuery({
    queryKey: ['startups', 'eligibility'],
    // React Query rejects `undefined` as query data - checkStartupEligibility
    // resolves with void, so map it to a real value.
    queryFn: () => checkStartupEligibility().then(() => true as const),
    retry: false,
  });
}
